import React, { useEffect } from 'react';
import $i18n from '@alife/panda-i18n';
import { CnEllipsis } from '@alife/cn-ui';
import { logCustom } from 'src/utils/tracker';
import { execSlot } from 'src/utils';
import './index.scss';
const langCode = $i18n?.getLang();
const HelpCard = ({ data, panelCode }) => {
    useEffect(() => {
        if (data.length) {
            data.forEach((item) => {
                logCustom(`EXP_${item.type}`, item.data, panelCode);
            });
        }
    }, [data]);
    const getHotLineText = (data) => {
        if (data?.hotlineConfig?.length > -1) {
            const findIndex = data?.hotlineConfig?.findIndex((m) => m?.language === langCode);
            if (findIndex > -1) {
                return data?.hotlineConfig[findIndex]?.hotlineText;
            }
            else {
                data.desc;
            }
        }
        else {
            return data.desc;
        }
    };
    return (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-card-item' }, data.map((m) => {
        const showText = m?.type === 'hotline' ? getHotLineText(m?.data) : execSlot(m?.desc, 'card-item-desc', data);
        if (!showText) {
            return null;
        }
        const title = execSlot(m.title, 'card-item-title', data);
        return (React.createElement("div", { key: m.type, className: `cn-ui-intelli-assistant-panel-card-item-li ${m?.canClick ? 'cn-ui-intelli-assistant-panel-card-item-li-arrow' : ''}`, onClick: () => {
                m.onClick?.();
                logCustom(`CLK_${m.type}`, m.data, panelCode);
            } },
            React.createElement("span", { className: 'cn-ui-intelli-assistant-panel-card-item-li-icon' },
                React.createElement("img", { src: `${m.icon ||
                        'https://img.alicdn.com/imgextra/i1/O1CN01ajxCic1kySrFVrGcV_!!6000000004752-55-tps-48-48.svg'}` })),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-card-item-li-title' },
                React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-card-item-li-text' }, typeof title === 'string' ? React.createElement(CnEllipsis, null, title) : title),
                React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-card-item-li-desc new-assistant-version' }, showText))));
    })));
};
export default HelpCard;
